import { SearchInput } from '../shared';
import { SortOrder, OfficeEquipmentSortType } from '../enums';

export class GetOfficeEquipmentsInput extends SearchInput<OfficeEquipmentSortType> {
    public employeeId: number | null;
    public officeEquipmentTypeId: number | null;
    public officeEquipmentBrandId: number | null;
    public officeEquipmentModelId: number | null;

    constructor() {
        super(OfficeEquipmentSortType.EmployeeFullName);
        this.sortOrder = SortOrder.Ascending;
        this.employeeId = null;
        this.officeEquipmentTypeId = null;
        this.officeEquipmentBrandId = null;
        this.officeEquipmentModelId = null;
    }
}
